export enum DownloadCouponTargetInfoType {
  Collection = 'Collection',
  Product = 'Product',
  Magazine = 'Magazine',
  FripMagazine = 'FripMagazine',
}
